
import { Box, Typography, Grid2 as Grid, useTheme, useMediaQuery, Stack } from "@mui/material";
import './company-details.css';
import CompanyH from "../../../../assets/images/Company_Home.png";
import IMG_politica from "../../../../assets/images/politica.png";
import IMG_valores from "../../../../assets/images/valores.png";
import IMG_modelo from "../../../../assets/images/modelo.png"

function CompanyDetails() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(700));
  const widthText = isMobile ? "100%" : "75%";
  return (
    <Box className="company-details-container">
      <Typography className="title-details title-history"
        sx={{
          fontFamily: "BloodOrange, sans-serif",
          mt: 8
        }}
      >
        ✧ La receta de nuestra historia ✧
      </Typography>
      <Grid container spacing={2} className="company-details-content" sx={{ mt: 2 }} >
        <Grid size={isMobile ? 12 : 6} className="company-image-section">
          <img src={CompanyH} className="company-image" alt="company-image" />
        </Grid>
        <Grid size={isMobile ? 10 : 6} className="text-details-section">
          <Typography
            className="company-text"
            variant="body1"
            sx={{ mt: 4, width: widthText }}
          >
            Desde 1959, Marián® se ha consolidado como un símbolo de calidad y autenticidad mexicana.
          </Typography>
          <Typography
            className="company-text"
            variant="body1"
            sx={{ mt: 2, width: widthText }}
          >
            Nacida en la emblemática colonia Roma de la Ciudad de México, la marca se originó por el profundo amor por las galletas y la búsqueda incansable del sabor perfecto.
          </Typography>
          <Typography
            className="company-text"
            variant="body1"
            sx={{ mt: 2, width: widthText }}
          >
            Con el tiempo, esa pasión se tradujo en una receta única que conquistó corazones y paladares.
          </Typography>
          <Typography
            className="company-text"
            variant="body1"
            sx={{ mt: 2, width: widthText }}
          >
            Comenzando como un emprendimiento de venta casa a casa, su éxito creció de manera orgánica, gracias a los clientes que, una vez probadas las delicias, regresaban para seguir disfrutando de ese exquisito sabor.
          </Typography>
          <Typography
            className="company-text"
            variant="body1"
            sx={{ mt: 2, width: widthText }}
          >
            Así, el sueño del fundador se hizo realidad: <b>transmitir una pasión por la calidad y el sabor.</b>
          </Typography>
          <Typography
            className="company-text"
            variant="body1"
            sx={{ mt: 2, width: widthText }}
          >
            Su misión es simple: ofrecer galletas que despierten emociones y recuerdos, productos elaborados con amor, dedicación y que en cada bocado te transporten a esos momentos especiales.
          </Typography>
          <Typography
            className="company-text"
            variant="body1"
            sx={{ mt: 2 }}
          >
            Porque cada galleta cuenta una historia.
          </Typography>
          <Typography
            className="company-text"
            variant="body1"
            sx={{ mt: 2 }}
          >
            Marián®, reinventamos la pasión por el sabor.
          </Typography>
        </Grid>
      </Grid>
      <Typography className="title-details title-politica"
        sx={{
          fontFamily: "BloodOrange, sans-serif",
          mt: 20
        }}
      >
        ✧ Política de Grupo Marián® ✧
      </Typography>
      <Grid container spacing={2} className="politica-content" sx={{ mt: 2 }} >
        <Grid size={isMobile ? 12 : 6} className="text-politica-section">
          <Typography
            className="company-text"
            variant="body1"
            sx={{ mt: 4, width: widthText }}
          >
            En grupo Marián® nuestro compromiso es producir galletas con inocuidad y calidad que satisfagan las necesidades y experiencias de nuestros clientes, consumidores y partes interesadas, trabajando en equipo, generando mejora continua, basado en la integridad salud y seguridad de nuestros colaboradores.
          </Typography>
          <Typography
            className="company-text"
            variant="body1"
            sx={{ mt: 2, width: widthText }}
          >
            Para lograrlo, trabajamos en una comunicación, clara tanto interna como externa, que permita dar respuesta a los requisitos legales y reglamentarios relativos al sistema de gestión de inocuidad, trabajando con todo el personal la competencia en materia de buenas prácticas de manufactura, brindando los medios e instalaciones que le permitan mantener estándares de higiene.
          </Typography>
          <Typography
            className="company-text"
            variant="body1"
            sx={{ mt: 2, width: widthText }}
          >
            La dirección se compromete a revisar esta política, así como el o los objetivos anualmente, realizar los ajustes necesarios, para asegurar que se mantiene su adecuación a los requisitos.
          </Typography>
        </Grid>
        <Grid size={isMobile ? 12 : 6} className="politica-image-section">
          <img src={IMG_politica} className="politica-image" alt="company-image" />
        </Grid>
      </Grid>
      <Typography className="title-details title-valores"
        sx={{
          fontFamily: "BloodOrange, sans-serif",
          mt: 20
        }}
      >
        ✧ Los valores que nos guían ✧
      </Typography>
      <Grid container spacing={2} className="valores-content" sx={{ mt: 2 }} >
        <Grid size={isMobile ? 12 : 6} className="valores-image-section">
          <img src={IMG_valores} className="valores-image" alt="company-image" />
        </Grid>
        <Grid size={isMobile ? 12 : 6}>
          <Stack spacing={2} className="text-valores-section">
            {[
              {
                titulo: "Respeto",
                texto:
                  "Reconocer y apreciar el trabajo de los demás. Ser amable y tratar bien a las personas. Saber escuchar y aceptar diferencias.",
              },
              {
                titulo: "Integridad",
                texto:
                  "Pensar, decir y hacer, de manera congruente. Ser cabal. Saber admitir errores. Ser constante y consistente.",
              },
              {
                titulo: "Honestidad",
                texto: "Hablar con la verdad. Actuar con ética y rectitud.",
              },
              {
                titulo: "Equidad / Justicia",
                texto: "Tratar a todos por igual, sin distinción de sexo, edad, credo o raza.",
              },
              {
                titulo: "Lealtad",
                texto:
                  "Ser fiel a los principios de la empresa. Ser discreto. Tener amor a la camiseta. Lograr afinidad de intereses entre la empresa y la persona.",
              },
              {
                titulo: "Responsabilidad",
                texto:
                  "Asumir compromisos y cumplir obligaciones. Responder por nuestros actos.",
              },
            ].map((valor) => (
              <Box key={valor.titulo}>
                <Typography variant="subtitle1" sx={{
                  color: "#E66671", fontWeight: "bold", fontFamily: "BloodOrange, sans-serif",
                }}>
                  {valor.titulo}
                </Typography>
                <Typography variant="body2" sx={{ color: "#333" }} className="company-text"
                >
                  {valor.texto}
                </Typography>
              </Box>
            ))}
          </Stack>
        </Grid>
      </Grid>
      <Typography className="title-details title-valores"
        sx={{
          color: "#E66671",
          fontWeight: "bold",
          textAlign: "center",
          fontFamily: "BloodOrange, sans-serif",
          mt: 12
        }}
      >
        ✧ Modelo de Competencias ✧
      </Typography>
      <Grid container spacing={1} className="modelo-content">
        <Grid size={isMobile ? 12 : 12} className="modelo-image-section">
          <img src={IMG_modelo} className="modelo-image" alt="company-image" />
        </Grid>
      </Grid>
    </Box>
  );
}

export default CompanyDetails;